import { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../../components/ui/dialog';
import { Plus, UserPlus } from 'lucide-react';
import { toast } from 'sonner';

const AddProviderLightbox = ({ open, onOpenChange, onAdd }) => {
  const [form, setForm] = useState({ name: '', npi: '', taxId: '', specialty: '', phone: '', address: '', city: '', state: '', zip: '' });
  const set = (k, v) => setForm(p => ({ ...p, [k]: v }));

  const handleSave = () => {
    if (!form.name || !form.npi) { toast.error('Name and NPI are required'); return; }
    onAdd({ ...form, id: `PROV-${Date.now()}` });
    setForm({ name: '', npi: '', taxId: '', specialty: '', phone: '', address: '', city: '', state: '', zip: '' });
    onOpenChange(false);
    toast.success(`Provider ${form.name} added`);
  };

  const Field = ({ label, field, mono, placeholder, required }) => (
    <div>
      <label style={{ fontSize: 10, color: '#aaa', textTransform: 'uppercase', display: 'block', marginBottom: 2 }}>{label}{required && <span style={{ color: '#ef4444' }}> *</span>}</label>
      <input value={form[field]} onChange={e => set(field, e.target.value)} placeholder={placeholder || ''} style={{ width: '100%', height: 32, padding: '0 10px', borderRadius: 6, border: '1px solid #d1d5db', fontSize: 12, fontFamily: mono ? 'monospace' : 'inherit', outline: 'none' }} className="focus:border-blue-400" data-testid={`new-provider-${field}`} />
    </div>
  );

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md p-0 gap-0" data-testid="add-provider-dialog">
        <DialogHeader className="p-4 pb-3 border-b">
          <DialogTitle className="flex items-center gap-2 text-base"><UserPlus className="h-4 w-4" /> Add New Provider</DialogTitle>
        </DialogHeader>
        <div className="p-4 space-y-3">
          <div className="grid grid-cols-2 gap-3">
            <Field label="Provider Name" field="name" placeholder="Dr. Jane Smith" required />
            <Field label="NPI" field="npi" mono placeholder="1234567890" required />
          </div>
          <div className="grid grid-cols-2 gap-3">
            <Field label="Tax ID" field="taxId" mono placeholder="XX-XXXXXXX" />
            <Field label="Specialty" field="specialty" placeholder="Internal Medicine" />
          </div>
          <Field label="Phone" field="phone" placeholder="(555) 123-4567" />
          <Field label="Street Address" field="address" placeholder="123 Medical Dr" />
          <div className="grid grid-cols-3 gap-3">
            <Field label="City" field="city" placeholder="New York" />
            <Field label="State" field="state" placeholder="NY" />
            <Field label="ZIP" field="zip" placeholder="10001" />
          </div>
          <div className="flex items-center gap-2 pt-2">
            <button onClick={handleSave} style={{ flex: 1, height: 36, borderRadius: 8, background: '#111', color: '#fff', fontSize: 13, fontWeight: 500, border: 'none', cursor: 'pointer' }} className="flex items-center justify-center gap-1.5 transition-opacity hover:opacity-90" data-testid="save-provider-btn"><Plus style={{ width: 14, height: 14 }} /> Add Provider</button>
            <button onClick={() => onOpenChange(false)} style={{ height: 36, padding: '0 16px', borderRadius: 8, background: '#fff', color: '#555', fontSize: 13, border: '1px solid #e8e8e8', cursor: 'pointer' }}>Cancel</button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default AddProviderLightbox;
